<template>
    <div
        ref="tabContainer"
        class="flex"
        :class="containerClass"
        :style="{ paddingLeft: spaceNavComputed, paddingRight: spaceNavComputed }"
    >
        <!-- <template> -->
        <div
            v-for="(item, idx) of items"
            :key="`tab-${idx}`"
            :ref="setItemRef"
            class="cursor-pointer hover:bg-primary-lighter text-center uppercase whitespace-nowrap border-t-2 first:ml-0 last:mr-0"
            :class="boxClass(item, idx)"
            :style="{ minWidth: minWidthComputed, borderTopColor: 'transparent' }"
            @click="selectTab(item, idx)"
        >{{ getLabel(item) }}</div>
        <!-- </template> -->
    </div>
</template>

<script>
import PropsHelper from "@/helper/PropsHelper"

export default {
    name: "VTabNav",
    props: {
        modelValue: {
            type: [Number, String],
            default: 0
        },
        items: {
            type: Array,
            default: () => []
        },
        itemText: {
            type: String,
            default: "text"
        },
        itemValue: {
            type: [Number, String],
            default: "value"
        },
        minWidth: {
            type: [String, Number],
            default: undefined
        },
        textColor: {
            type: String,
            default: "text-red-1"
        },
        textColorNoneActive: {
            type: String,
            default: "text-primary"
        },
        grow: {
            type: Boolean
        },
        scrollable: {
            type: Boolean
        },
        textClass: {
            type: String,
            defaulr: ""
        },
        paddingX: {
            type: String,
            default: "px-0"
        },
        paddingY: {
            default: 'py-3'
        },
        fontBold: {
            type: Boolean,
            default: false
        },
        fontSize: {
            type: String,
            default: 'text-base'
        },
        borderColorActive: {
            type: String,
            default: 'border-red-1'
        },
        spaceNav: {
            type: [String, Number],
            default: undefined
        },
        gap: {
            type: String,
            default: 'mx-0'
        }
    },
    data: function () {
        return {
            activeIndex: 0,
            itemRefs: []
        }
    },
    computed: {
        minWidthComputed: function () {
            if (this.minWidth != undefined) {
                if (typeof this.minWidth == "number") {
                    return `${this.minWidth}px`
                } else {
                    if (this.minWidth.indexOf("px") != -1) {
                        return this.minWidth
                    } else if (this.minWidth.indexOf("%") != -1) {
                        return this.minWidth
                    } else {
                        return `${this.minWidth}px`
                    }
                }
            }
            return null
        },
        containerClass: function () {
            let cls = []
            if (this.scrollable) {
                cls.push('flex-nowrap')
                cls.push('overflow-x-auto')
                cls.push('w-full')
                cls.push('max-w-full')
                cls.push('hide-scroll')
            }
            cls.push('border-b')

            return cls
        },
        spaceNavComputed: function () {
            return PropsHelper.getBoxUnit(this.spaceNav)
        }
    },
    watch: {
        modelValue: function (val) {
            this.activeIndex = this.getTabIndex(val)
            if (this.scrollable) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.focusTab()
                    }, 100);
                })
            }
        }
    },
    emits: ["update:modelValue"],
    beforeUpdate: function () {
        this.itemRefs = []
    },
    mounted: function () {
        // console.log(this.itemRefs)
    },
    methods: {
        boxClass: function (item, idx) {

            if (item[this.itemValue] != undefined) {
                if (item[this.itemValue] == this.modelValue) {
                    return this.setClassActive()
                }
            } else {
                if (idx == this.modelValue) {
                    return this.setClassActive()
                }
            }

            return this.setClassNoneActive()
        },
        setShareClass: function () {
            let cls = []
            if (this.grow) {
                cls.push('flex-1')
            }
            if (this.fontBold) {
                cls.push('font-semibold')
            }

            cls.push(this.paddingX)
            cls.push(this.textClass)
            cls.push(this.fontSize)
            cls.push(this.paddingY)
            cls.push(this.gap)

            return cls
        },
        setClassActive: function () {
            let cls = this.setShareClass()
            cls.push('border-b-2')
            cls.push(this.textColor)
            cls.push(this.borderColorActive)
            return cls
        },
        setClassNoneActive: function () {
            let cls = this.setShareClass()
            // cls.push('border-b')
            cls.push(this.textColorNoneActive)
            return cls
        },
        selectTab: function (item, idx) {
            let val = this.getTabValue(item, idx)
            this.setTracking(item)
            this.$emit("update:modelValue", val)
        },
        setTracking: function (selectedItem) {
            var currentPath = this.$route.path;
            if (currentPath.indexOf('platinum-campaigns') > 0) {
                this.tracking.event('category', 'click_category', selectedItem.text, null);
            }
        },
        getLabel: function (item) {
            // console.log(typeof item == "string")
            if (typeof item == "string") {
                return item
            } else if (typeof item == "object") {
                return item[this.itemText]
            } else {
                return "Can not render"
            }
        },
        getTabValue: function (item, idx) {
            return item[this.itemValue] != undefined ? item[this.itemValue] : idx
        },
        getTabIndex: function (value) {
            return this.items.findIndex(x => {
                if (x[this.itemValue] != undefined) {
                    return x[this.itemValue] == value
                } else {
                    return x == value
                }
            })
        },
        focusTab: function () {
            /**@type HTMLElement */
            // let elContainer = this.$refs.tabContainer
            // console.log(elContainer)

            // console.log(this.itemRefs[this.activeIndex])
            /**@type HTMLElement */
            let el = this.itemRefs[this.activeIndex]
            if (el != null) {
                let inlineConfig = 'nearest'
                if (this.activeIndex == 0) {
                    inlineConfig = 'end'
                } else if (this.activeIndex == this.items.length - 1) {
                    inlineConfig = 'start'
                } else {
                    inlineConfig = 'nearest'
                }
                el.scrollIntoView({ block: 'end', inline: inlineConfig, behavior: 'smooth' })
            }
        },
        setItemRef(el) {
            if (el) {
                this.itemRefs.push(el)
            }
        }
    }
}
</script>
